/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useState, useEffect } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Link } from 'foundations-components/transitional/components/Link';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import Routes from 'ContentUtils/Routes';
import { EmailAddressTypes } from 'ContentUtils/constants/Emails';
import { fetchOwnedEmailAddresses, fetchConnectedInboxAccounts } from 'ContentData/api/Emails';
import { Select } from 'foundations-components/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.formWorkflowDependencies.followupEmailWorkflows.emailEditorPanel.fromAddress.${key}`;
function getEmailAddressOptions(verifiedEmailAddresses = [], connectedEmailAddresses = []) {
  const emailAddresses = [];
  const hubspotInboxes = [];
  const personalizationTokens = [];
  connectedEmailAddresses.concat(verifiedEmailAddresses).forEach(emailOption => {
    switch (emailOption.type) {
      case EmailAddressTypes.MERGE_TAG:
        personalizationTokens.push(emailOption);
        break;
      case EmailAddressTypes.HUBSPOT_HOSTED:
        hubspotInboxes.push(emailOption);
        break;
      default:
        emailAddresses.push(emailOption);
        break;
    }
  });
  const selectEmailAddressOptions = [];
  if (emailAddresses.length) {
    selectEmailAddressOptions.push({
      subheading: I18n.text(i18nKey('emailAddressOptionGroupLabels.emailAddresses')),
      options: emailAddresses
    });
  }
  if (hubspotInboxes.length) {
    selectEmailAddressOptions.push({
      subheading: I18n.text(i18nKey('emailAddressOptionGroupLabels.hubspotInboxes')),
      options: hubspotInboxes
    });
  }
  if (personalizationTokens.length) {
    selectEmailAddressOptions.push({
      subheading: I18n.text(i18nKey('emailAddressOptionGroupLabels.personalizationTokens')),
      options: personalizationTokens
    });
  }
  return selectEmailAddressOptions;
}
const EmailAddressSelect = ({
  showUnverifiedEmailError,
  onChange,
  value
}) => {
  const [emailAddressOptions, setEmailAddressOptions] = useState([]);
  const [connectedEmailAddresses, setConnectedEmailAddresses] = useState([]);
  const [verifiedEmailAddressesError, setVerifiedEmailAddressesError] = useState();
  const [connectedEmailAddressesError, setConnectedEmailAddressesError] = useState();
  useEffect(() => {
    Promise.all([fetchOwnedEmailAddresses().catch(() => setVerifiedEmailAddressesError( /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('verifiedEmailAddressesFetchError')
    }, "verifiedEmailAddressesFetchError"))), fetchConnectedInboxAccounts().catch(() => setConnectedEmailAddressesError( /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('connectedEmailAddressesFetchError')
    }, "connectedEmailAddressesFetchError")))]).then(([_ownedEmailAddresses, _connectedEmailAddresses]) => {
      const ownedEmailAddressOptions = Array.isArray(_ownedEmailAddresses) ? _ownedEmailAddresses.filter(({
        isVerified
      }) => isVerified).map(({
        content,
        type
      }) => ({
        text: content,
        value: content,
        type
      })) : [];
      const connectedEmailAddressOptions = Array.isArray(_connectedEmailAddresses) ? _connectedEmailAddresses.filter(({
        connected
      }) => connected).map(({
        email: emailAddress,
        sendFromEmail,
        emailAccountType
      }) => ({
        type: emailAccountType,
        text: sendFromEmail || emailAddress,
        value: emailAddress
      })) : [];
      setConnectedEmailAddresses(connectedEmailAddressOptions);
      setEmailAddressOptions(getEmailAddressOptions(ownedEmailAddressOptions, connectedEmailAddressOptions));
    }).catch();
  }, []);
  const isConnectedInboxAccountEmailAddress = connectedEmailAddresses.some(({
    text
  }) => text === value);
  const errorMessages = [];
  if (showUnverifiedEmailError) {
    errorMessages.push( /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('unverifiedEmailError')
    }, "unverifiedEmailError"));
  }
  if (verifiedEmailAddressesError || connectedEmailAddressesError) {
    errorMessages.push(verifiedEmailAddressesError || connectedEmailAddressesError);
  }
  return /*#__PURE__*/_jsx(FormControl, {
    help: isConnectedInboxAccountEmailAddress && /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('connectedInboxInfo')
    }),
    error: errorMessages.length > 0,
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('label')
    }),
    required: true,
    validationMessage: /*#__PURE__*/_jsx(TFlex, {
      direction: "column",
      children: errorMessages
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Select, {
        options: emailAddressOptions,
        onSelectedOptionChange: ({
          value: selectedEmail
        }) => onChange(selectedEmail),
        searchable: true,
        selectedItemsPlaceholder: I18n.text(i18nKey('placeholder'))
      }), /*#__PURE__*/_jsx(Link, {
        href: Routes.settings('users'),
        external: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('dropdownFooterLink')
        })
      })]
    })
  });
};
export default EmailAddressSelect;